import request from '@/utils/request'

export const userApi = {
  list: params => request.get('/system/user/list', { params }),
  create: data => request.post('/system/user', data),
  update: data => request.put('/system/user', data),
  remove: userId => request.delete(`/system/user/${userId}`),
  roleIds: userId => request.get(`/system/user/${userId}/roles`),
  updateRoles: (userId, roleIds) => request.put(`/system/user/${userId}/roles`, { roleIds })
}

export const adminUserApi = {
  list: params => request.get('/system/admin/list', { params }),
  create: data => userApi.create({ ...data, clientType: 'admin' }),
  update: data => userApi.update({ ...data, clientType: 'admin' }),
  remove: userApi.remove,
  roleIds: userApi.roleIds
}

export const appUserApi = {
  list: params => request.get('/system/app-user/list', { params }),
  create: data => userApi.create({ ...data, clientType: 'app' }),
  update: data => userApi.update({ ...data, clientType: 'app' }),
  remove: userApi.remove
}

export const coachApi = {
  list: params => request.get('/system/coach/list', { params }),
  athletes: coachUserId => request.get(`/system/coach/${coachUserId}/athletes`)
}

export const roleApi = {
  list: params => request.get('/system/role/list', { params }),
  create: data => request.post('/system/role', data),
  update: data => request.put('/system/role', data),
  remove: roleId => request.delete(`/system/role/${roleId}`),
  menuIds: roleId => request.get(`/system/role/${roleId}/menus`),
  updateMenus: (roleId, menuIds) => request.put(`/system/role/${roleId}/menus`, { menuIds })
}

export const menuApi = {
  tree: () => request.get('/system/menu/tree'),
  list: params => request.get('/system/menu/list', { params }),
  create: data => request.post('/system/menu', data),
  update: data => request.put('/system/menu', data),
  remove: menuId => request.delete(`/system/menu/${menuId}`)
}

export const policyApi = {
  list: params => request.get('/system/policy/list', { params }),
  create: data => request.post('/system/policy', data),
  update: data => request.put('/system/policy', data),
  remove: id => request.delete(`/system/policy/${id}`)
}

export const deviceModelApi = {
  list: params => request.get('/system/device-model/list', { params }),
  create: data => request.post('/system/device-model', data),
  update: data => request.put('/system/device-model', data),
  remove: id => request.delete(`/system/device-model/${id}`)
}
